import { Checkbox } from 'uikit';

import type React from 'react';
import { useCallback } from 'react';

import type { ITableLikeTreeFilterItem } from '../context';

interface ILeftFilterCheckCell {
    checkedIds: number[];
    item: ITableLikeTreeFilterItem;
    onCheckChange: (item: ITableLikeTreeFilterItem, checked: boolean) => any;
    disabled?: boolean;
}

export const LeftFilterCheckCell: React.FC<ILeftFilterCheckCell> = (props) => {
    const { checkedIds, item, onCheckChange, disabled } = props;

    const onChange = useCallback(
        ({ checked }) => {
            onCheckChange(item, checked);
        },
        [item, onCheckChange],
    );

    return (
        <Checkbox
            disabled={disabled}
            checked={!!checkedIds.length && checkedIds.includes(item.id)}
            onChange={onChange}
            size="l"
        />
    );
};

LeftFilterCheckCell.displayName = 'LeftFilterCheckCell';
